export default "__VITE_ASSET__DhYU3Ca$__"